import {
  request
} from '@/utils/request.js'

const getUserList = (data, callback, errCallback, finCallback) => {
  request({
    url: '/admin/approve/users',
    method: 'GET',
    params: data,
    success: callback,
    fail: errCallback,
    complete: finCallback
  })
}


const getOrganizationList = (data, callback, errCallback, finCallback) => {
  request({
    url: '/admin/approve/organization',
    method: 'GET',
    params: data,
    success: callback,
    fail: errCallback,
    complete: finCallback
  })
}

const getPlayersOfOrg = (orgId, callback, errCallback, finCallback) => {
  request({
    url: `/admin/approve/players/${orgId}`,
    method: 'GET',
    success: callback,
    fail: errCallback,
    complete: finCallback
  })
}

const orgApprove = (orgId, state, callback, errCallback, finCallback) => {
  request({
    url: `/admin/approve/organization/${orgId}/${state}`,
    method: 'POST',
    success: callback,
    fail: errCallback,
    complete: finCallback
  })
}


const getUserInfoList = (data, callback, errCallback, finCallback, options) => {
  request({
    url: '/admin/approve/user_info',
    method: 'GET',
    params: data,
    noLoading: options && options.noLoading,
    success: callback,
    fail: errCallback,
    complete: finCallback
  })
}


const userInfoApprove = (userInfoId, state, callback, errCallback, finCallback) => {
  request({
    url: `/admin/approve/user_info/${userInfoId}/${state}`,
    method: 'POST',
    success: callback,
    fail: errCallback,
    complete: finCallback
  })
}


const getFilesList = (data, callback, errCallback, finCallback) => {
  request({
    url: '/upload/files',
    method: 'GET',
    params: data,
    success: callback,
    fail: errCallback,
    complete: finCallback
  })
}


const addUploadFile = (data, callback, errCallback, finCallback) => {
  request({
    url: `/upload/files`,
    method: 'POST',
    data: data,
    success: callback,
    fail: errCallback,
    complete: finCallback
  })
}


const deleteUploadFile = (fileId, callback, errCallback, finCallback) => {
  request({
    url: `/upload/files/${fileId}`,
    method: 'DELETE',
    success: callback,
    fail: errCallback,
    complete: finCallback
  })
}


const getGamesList = (data, callback, errCallback, finCallback) => {
  request({
    url: '/admin/games',
    method: 'GET',
    params: data,
    success: callback,
    fail: errCallback,
    complete: finCallback
  })
}


const addGame = (data, callback, errCallback, finCallback) => {
  request({
    url: `/admin/games`,
    method: 'POST',
    data: data,
    success: callback,
    fail: errCallback,
    complete: finCallback
  })
}


const deleteGame = (gameId, callback, errCallback, finCallback) => {
  request({
    url: `/admin/games/${gameId}`,
    method: 'DELETE',
    success: callback,
    fail: errCallback,
    complete: finCallback
  })
}


const getGameItemsList = (data, callback, errCallback, finCallback) => {
  request({
    url: '/admin/games/items',
    method: 'GET',
    params: data,
    success: callback,
    fail: errCallback,
    complete: finCallback
  })
}


const addGameItem = (data, callback, errCallback, finCallback) => {
  request({
    url: `/admin/games/items`,
    method: 'POST',
    data: data,
    success: callback,
    fail: errCallback,
    complete: finCallback
  })
}


const deleteGameItem = (gameId, callback, errCallback, finCallback) => {
  request({
    url: `/admin/games/items/${gameId}`,
    method: 'DELETE',
    success: callback,
    fail: errCallback,
    complete: finCallback
  })
}

const deleteGameItemResult = (resultId, callback, errCallback, finCallback) => {
  request({
    url: `/admin/games/result/${resultId}`,
    method: 'DELETE',
    success: callback,
    fail: errCallback,
    complete: finCallback
  })
}


const getHeadPicList = (data, callback, errCallback, finCallback) => {
  request({
    url: '/homepage/head_pic',
    method: 'GET',
    params: data,
    success: callback,
    fail: errCallback,
    complete: finCallback
  })
}


const addHeadPic = (data, callback, errCallback, finCallback) => {
  request({
    url: `/admin/homepage/head_pic`,
    method: 'POST',
    data: data,
    success: callback,
    fail: errCallback,
    complete: finCallback
  })
}


const deleteHeadPic = (headPicId, callback, errCallback, finCallback) => {
  request({
    url: `/admin/homepage/head_pic/${headPicId}`,
    method: 'DELETE',
    success: callback,
    fail: errCallback,
    complete: finCallback
  })
}


const getNoticesList = (data, callback, errCallback, finCallback) => {
  request({
    url: '/admin/homepage/notices',
    method: 'GET',
    params: data,
    success: callback,
    fail: errCallback,
    complete: finCallback
  })
}


const addNotices = (data, callback, errCallback, finCallback) => {
  request({
    url: `/admin/homepage/notice`,
    method: 'POST',
    data: data,
    success: callback,
    fail: errCallback,
    complete: finCallback
  })
}


const deleteNotices = (noticeId, callback, errCallback, finCallback) => {
  request({
    url: `/admin/homepage/notice/${noticeId}`,
    method: 'DELETE',
    success: callback,
    fail: errCallback,
    complete: finCallback
  })
}


const getPartnersList = (data, callback, errCallback, finCallback) => {
  request({
    url: '/homepage/partners',
    method: 'GET',
    params: data,
    success: callback,
    fail: errCallback,
    complete: finCallback
  })
}


const addPartners = (data, callback, errCallback, finCallback) => {
  request({
    url: `/admin/homepage/partner`,
    method: 'POST',
    data: data,
    success: callback,
    fail: errCallback,
    complete: finCallback
  })
}


const deletePartners = (partnerId, callback, errCallback, finCallback) => {
  request({
    url: `/admin/homepage/partner/${partnerId}`,
    method: 'DELETE',
    success: callback,
    fail: errCallback,
    complete: finCallback
  })
}

const importResult = (gameItemId, data, callback, errCallback, finCallback) => {
  request({
    url: `/admin/games/results/import/${gameItemId}`,
    method: 'POST',
    data: data,
    success: callback,
    fail: errCallback,
    complete: finCallback
  })
}


const getPointsSeasons = (callback, errCallback, finCallback) => {
  request({
    url: '/admin/points/seasons',
    method: 'GET',
    success: callback,
    fail: errCallback,
    complete: finCallback
  })
}

const getPointsGames = (data, callback, errCallback, finCallback) => {
  request({
    url: '/admin/points/games',
    method: 'GET',
    params: data,
    success: callback,
    fail: errCallback,
    complete: finCallback
  })
}

const setGameSeason = (data, callback, errCallback, finCallback) => {
  request({
    url: '/admin/points/game_season',
    method: 'POST',
    data: data,
    success: callback,
    fail: errCallback,
    complete: finCallback
  })
}

const clearGameSeason = (gameId, callback, errCallback, finCallback) => {
  request({
    url: `/admin/points/game_season/${gameId}`,
    method: 'DELETE',
    success: callback,
    fail: errCallback,
    complete: finCallback
  })
}

const toggleExcludeFromPoints = (data, callback, errCallback, finCallback) => {
  request({
    url: '/admin/points/game_season/exclude',
    method: 'POST',
    data: data,
    success: callback,
    fail: errCallback,
    complete: finCallback
  })
}

const getPointsRanking = (data, callback, errCallback, finCallback) => {
  request({
    url: '/admin/points/ranking',
    method: 'GET',
    params: data,
    success: callback,
    fail: errCallback,
    complete: finCallback
  })
}

const getPointsAdjustments = (data, callback, errCallback, finCallback) => {
  request({
    url: '/admin/points/adjustments',
    method: 'GET',
    params: data,
    success: callback,
    fail: errCallback,
    complete: finCallback
  })
}

const addPointsAdjustment = (data, callback, errCallback, finCallback) => {
  request({
    url: '/admin/points/adjustments',
    method: 'POST',
    data: data,
    success: callback,
    fail: errCallback,
    complete: finCallback
  })
}

const batchAddPointsAdjustments = (data, callback, errCallback, finCallback) => {
  request({
    url: '/admin/points/adjustments/batch',
    method: 'POST',
    data: data,
    success: callback,
    fail: errCallback,
    complete: finCallback
  })
}

const lookupPointsUsers = (data, callback, errCallback, finCallback) => {
  request({
    url: '/admin/points/lookup_users',
    method: 'POST',
    data: data,
    success: callback,
    fail: errCallback,
    complete: finCallback
  })
}

const deletePointsAdjustment = (adjustmentId, callback, errCallback, finCallback) => {
  request({
    url: `/admin/points/adjustments/${adjustmentId}`,
    method: 'DELETE',
    success: callback,
    fail: errCallback,
    complete: finCallback
  })
}


export {
  getUserList,
  getOrganizationList,
  getPlayersOfOrg,
  orgApprove,
  getUserInfoList,
  userInfoApprove,
  getFilesList,
  addUploadFile,
  deleteUploadFile,
  getGamesList,
  addGame,
  deleteGame,
  getGameItemsList,
  addGameItem,
  deleteGameItem,
  deleteGameItemResult,
  getHeadPicList,
  addHeadPic,
  deleteHeadPic,
  getNoticesList,
  addNotices,
  deleteNotices,
  getPartnersList,
  addPartners,
  deletePartners,
  importResult,
  getPointsSeasons,
  getPointsGames,
  setGameSeason,
  clearGameSeason,
  toggleExcludeFromPoints,
  getPointsRanking,
  getPointsAdjustments,
  addPointsAdjustment,
  batchAddPointsAdjustments,
  lookupPointsUsers,
  deletePointsAdjustment
}


// WEBPACK FOOTER //
// ./src/servers/admin.js